import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const toggleButton = document.getElementById("accounts-search-toggle");
    const searchFieldContainer = document.getElementById("search-field-container");
    const subAccountsMenu = document.getElementById("sub-accounts-menu");
    const searchInput = document.getElementById("search-input");
    const searchIcon = document.getElementById("search-icon");
    const clearSearchIcon = document.getElementById("clear-search-icon");
    const searchResults = document.getElementById("search-results");
    const searchResultsDivider = document.getElementById("search-results-divider");
    const subAccountResults = document.getElementById("sub-account-results");
    const closeAccSearchBtn = document.getElementById("close-account-search");

    const parent_account_id = toggleButton.dataset.parentAccountId
    const selected_account_id = toggleButton.dataset.accountId

    toggleButton.addEventListener("click", toggleSearch);
    closeAccSearchBtn.addEventListener("click", toggleSearch);
    searchInput.addEventListener("input", handleSearch);
    clearSearchIcon.addEventListener("click", clearSearch);

    let loadingTimeout;

    function toggleSearch() {
      if (searchFieldContainer.classList.contains("open")) {
        subAccountsMenu.classList.toggle("hidden");
        searchFieldContainer.classList.toggle("hidden");
        toggleButton.classList.toggle("hidden");
        
        searchFieldContainer.classList.remove("open");
        searchFieldContainer.style.maxHeight = "0";
        searchFieldContainer.style.opacity = "0";
        searchFieldContainer.style.transform = "translateY(-10px)";
      } else {
        fetchSubAccounts();

        subAccountsMenu.classList.toggle("hidden");
        searchFieldContainer.classList.toggle("hidden");
        toggleButton.classList.toggle("hidden");
        
        searchFieldContainer.classList.add("open");
        searchFieldContainer.style.maxHeight = searchFieldContainer.scrollHeight + "px";
        searchFieldContainer.style.opacity = "1";
        searchFieldContainer.style.transform = "translateY(0)";
      }
      searchInput.focus();
    }

    function handleSearch() {
      filterSubAccounts();
      fetchAllAccounts();
    }

    async function fetchSubAccounts() {
      if (subAccountResults.dataset.fetched === "true") {
        return;
      }

      try {
        const response = await fetch(`/admin/accounts/menu_items?parent_id=${parent_account_id}`, {
          headers: { Accept: "application/json" }
        });
        const results = await response.json();

        subAccountResults.innerHTML = results.map(result => {
          let selected = String(result[0]) === selected_account_id
          let bullet = selected ? "• " : "";

          return `
            <div>
              <a href="/admin/accounts/${result[0]}" style="font-family:Space Grotesk" class="text-sm sub-accounts-result truncate overflow-hidden block w-full px-2 py-1 hover:text-gray-200 cursor-pointer rounded-lg ${selected ? "text-gray-100 bg-gray-900 pl-3" : "text-gray-400"}">
                ${bullet}${result[2]}
              </a>
            </div>
          `;
          }).join("");
          subAccountResults.dataset.fetched = "true";
      } catch (error) {
        console.error("Sub accounts search error:", error);
      }
    }

    function filterSubAccounts() {
      const divs = document.querySelectorAll(".sub-accounts-result")
      const query = searchInput.value.trim();
      const regex = new RegExp(query, "i");    

      divs.forEach(div => {
        const text = div.textContent.trim();

        if (regex.test(text)) {
          div.classList.remove("hidden");
        } else {
          div.classList.add("hidden");
        }
      })
    }

    let allTimeoutId;
    let allCurrentController;

    async function fetchAllAccounts() {
      clearTimeout(allTimeoutId);

      if (allCurrentController) {
        allCurrentController.abort();
      }

      allCurrentController = new AbortController();
      allTimeoutId = setTimeout(async () => {
        const query = searchInput.value.trim();

        if (query === "") {
          searchResults.innerHTML = "";
          searchIcon.classList.remove("hidden");
          clearSearchIcon.classList.add("hidden");
          searchResultsDivider.classList.add("hidden");
          
          return;
        } else {
          searchIcon.classList.add("hidden");
          clearSearchIcon.classList.remove("hidden");
          searchResultsDivider.classList.remove("hidden");
        }
        
        try {
          const response = await fetch(`/admin/accounts/menu_items?sq=${encodeURIComponent(query)}`, { 
            headers: { Accept: "application/json" }
          });
          const results = await response.json();

          clearTimeout(loadingTimeout);

          searchResults.innerHTML = results.filter(
            (arr) => arr[1] != parent_account_id &&
              arr[0] != selected_account_id &&
              arr[0] != parent_account_id
            ).map(result => `
            <div>
              <a href="/admin/accounts/${result[0]}" style="font-family:Space Grotesk" class="text-sm block w-full text-gray-200 px-2 py-1 hover:bg-gray-600 cursor-pointer truncate overflow-hidden">${result[2]}</a>
            </div>
          `).join("");
        } catch (error) {
          clearTimeout(loadingTimeout);
          console.error("Search error:", error);
        }
      }, 150);
    }

    function clearSearch() {
      searchInput.value = ""
      handleSearch()
    }
  }
}